import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

import Tag from '@components/tag/Tag'

interface Props {
  title: string
  link: { label: string; onClick: () => void }
  items: string[]
  onDelete: (idx: number) => void
}

const TagSection = ({ title, link, items, onDelete }: Props) => {
  const renderTags = (name: string, idx: number) => {
    return (
      <TagContainer key={name}>
        <Tag
          item={{ label: name, value: name }}
          onItemSelected={() => onDelete(idx)}
          selected
          rightIcon="cancel"
          ellipsized
        />
      </TagContainer>
    )
  }

  return (
    <Section>
      <SectionTitle>{title}</SectionTitle>
      <SectionBody>{items.map(renderTags)}</SectionBody>
      <Link onPress={link.onClick}>{link.label}</Link>
    </Section>
  )
}

export default TagSection

const Section = styled(View)`
  margin-bottom: 32px;
`

const SectionTitle = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin-bottom: 8px;
`

const SectionBody = styled(View)`
  flex-flow: row wrap;
`

const Link = styled(Text)`
  ${(props) => props.theme.fonts.Subheadline};
  color: ${(props) => props.theme.colors.primary};
`

const TagContainer = styled(View)`
  margin-bottom: 8px;
  margin-right: 8px;
`
